import { Component, OnInit } from '@angular/core';
import { HelpersService } from '../../../services/tools/helpers.service';
import { ReportsHelperService } from '../../../services/tools/reports-helpers.service';
import { ReportesPromotoresService } from "../../../services/reportes/reportes-promotores.service";
import { CreditosService } from "../../../services/creditos.service";
import { PromotoresService } from '../../../services/promotores.service';

@Component({
    selector: 'app-reporte-promotores-general',
    templateUrl: './reporte-promotores-general.component.html'
  })

export class ReportePromotoresGeneralComponent implements OnInit {
    public isNumber: Function = this.helper.isNumber;
    public reportData: any [] = [];
    public totales: any = {};
    public tiposCreditos: any[] = [];
    public promotores: any = [];
    //Filtros
    public tipoCredito: any = {};
    public promotor: any = {};
    //Helpers
    public isLoading: boolean = true;
    public areConveniosLoading: boolean = true;
    public isItemsArrayEmpty: boolean = null;

    constructor(
        private helperService: HelpersService,
        public helper: ReportsHelperService,
        private reportesService: ReportesPromotoresService,
        private creditosService: CreditosService,
        private promotoresServie: PromotoresService
    ){

    }

    public ngOnInit() {
        this.getTiposCreditos();
        this.updateReporte();
        this.getPromotores();
    }

    public updateReporte(){

        let filters = this.getFiltros();

        //Mostrar el ajax loading
        this.isLoading = true;

        this.reportesService.getReporteGeneral(filters).subscribe(
            (response)=>
            {
                const jsonResult = response.json();
                let items = [];
                let totales = {};

                if(jsonResult.content ){
                    if(jsonResult.content.items){
                        items = jsonResult.content.items;
                    }
                    if(jsonResult.content.totales){
                        totales = jsonResult.content.totales;
                    }
                }

                this.reportData = items;
                this.totales = totales;
                this.isLoading = false;
                this.isItemsArrayEmpty = this.reportData.length == 0;
            }, error =>
            {
                // se resuelve error 403 y 500
                this.helperService.httpGlobalError(error);

                if(error.status == 400) {
                    this.helperService.notification('ERROR', 'No se completó la acción. Por favor, intenta más tarde.', 'error');
                }
            }
        );
    }

    private getFiltros(){

        let filters = {
            tipoCredito: (this.tipoCredito && this.tipoCredito.id) ? this.tipoCredito.id : null,
            promotor: (this.promotor && this.promotor.id) ? this.promotor.id : null
        }

        return filters;
    }

    public print(){
        //Imprimir pantalla
        window.print();
    }

    public descargar() {

        let filters = this.getFiltros();

        this.reportesService.exportReporteGeneralToExcel(filters).subscribe(
            (response)=>
            {
            const fileUrl = window.URL.createObjectURL(response.blob());
            //Muestra el archivo en una nueva ventana
            window.open(fileUrl);
            }, error =>
            {
            // se resuelve error 403 y 500
            this.helperService.httpGlobalError(error);

            if(error.status == 400) {
                this.helperService.notification('ERROR', 'No se completó la acción. Por favor, intenta más tarde.', 'error');
            }
            }
        );
    }

    private getTiposCreditos(){
        this.creditosService.getTiposCreditos().subscribe(
            (response)=>
            {
                const jsonResult = response.json();
                if(jsonResult.content){
                    this.tiposCreditos = jsonResult.content;
                }
            }, error =>
            {
                // se resuelve error 403 y 500
                this.helperService.httpGlobalError(error);

                if(error.status == 400) {
                    this.helperService.notification('ERROR', 'No se completó la acción. Por favor, intenta más tarde.', 'error');
                }
            }
        );
    }

    private getPromotores(){

        this.promotoresServie.getAll({ order: 'nombre' }).subscribe(
            (response)=>
            {
                const jsonResult = response.json();
                this.promotores = jsonResult.content;
            }, error =>
            {
                // se resuelve error 403 y 500
                this.helperService.httpGlobalError(error);

                if(error.status == 400) {
                    this.helperService.notification('ERROR', 'No se completó la acción. Por favor, intenta más tarde.', 'error');
                }
            }
        );
    }

    public onSelectedPromotor(promotor: any){
        this.promotor = promotor;
        this.updateReporte();
    }

    public onSelectedTipoCredito(tipoCredito: any){
        this.tipoCredito = tipoCredito;
        this.updateReporte();
    }
}


// WEBPACK FOOTER //
// ./src/app/reportes/promotores/general/reporte-promotores-general.component.ts